type Buffer = {
    /** сам буфер, храним время последних N кадров */
    timings: number[];
    /** указатель на последний кадр */
    index: number;
    /** сумма времени всех последних N-кадров */
    sum: number;
};

export interface DrawingStats {
    fps: number;
    avgDrawTime: number;
}

export type DrawingStatsCounter = {
    countDrawingTime: (time: number) => void;
    countFrameRate: (time: number) => void;
    getCurrentDrawingStats: () => DrawingStats;
};

/**
 * Создаёт счётчики fps и среднего времени отрисовки на канвасе
 *
 * @param bufferSize - размер буфера кадров. чем больше буфер, тем точнее вычисления
 */
export const createDrawingStatsCounter = (bufferSize: number): DrawingStatsCounter => {
    let avgDrawTime = 0;
    let fps = 0;

    /**
     * Создаём пустой буффер
     */
    const createBuffer = (): Buffer => {
        return {
            timings: [],
            index: 0,
            sum: 0,
        };
    };

    const fpsBuffer = createBuffer();
    const avgDrawTimeBuffer = createBuffer();

    /**
     * Логика прохода окном по буферу размером = bufferSize.
     *
     * @param time - учитываемое время
     * @param buffer - буфер кадров величиной в bufferSize
     * @param callback - там считай что хочешь
     */
    const counter = (time: number, buffer: Buffer, callback: (sum: number, size: number) => void) => {
        if (buffer.timings.length === bufferSize) {
            // Когда буфер полный
            buffer.sum = buffer.sum - buffer.timings[buffer.index]; // указатель показывает на первый кадр, вычитаем его
            buffer.sum += time;
            buffer.timings[buffer.index] = time;
        } else {
            // пока буфер наполняется считаем по тем кадрам, что есть
            buffer.sum += time;
            buffer.timings[buffer.index] = time;
        }
        callback(buffer.sum, buffer.timings.length);

        buffer.index += 1;
        if (buffer.index === bufferSize) {
            buffer.index = 0;
        }
    };

    const countFrameRate = (frameTime: number) => {
        counter(frameTime, fpsBuffer, (sum, size) => {
            /**
             * смотрим сколько времени ушло на отрисовку последних N кадров
             * нормируем это время на секунду и вычисляем итоговый fps,
             * где N = bufferSize
             */
            fps = size / (sum / 1000);
        });
    };

    const countDrawingTime = (drawTime: number) => {
        counter(drawTime, avgDrawTimeBuffer, (sum, size) => {
            /** считаем среднее время отрисовки за последние N кадров, N = bufferSize */
            avgDrawTime = sum / size;
        });
    };

    const getCurrentDrawingStats = (): DrawingStats => {
        return { avgDrawTime, fps };
    };

    return { countDrawingTime, countFrameRate, getCurrentDrawingStats };
};
